import React from "react";
import Homenewajpv2 from "./Homenewajpv2";
import { getAjpPaidPlannerPage } from "../data/ajpPaidPlannerPages";

export default function AjpPaidAirportPlannerPage({ pageKey }) {
  const page = getAjpPaidPlannerPage(pageKey);
  return page ? <Homenewajpv2 pageConfig={page} /> : null;
}
